export const useIsButtonVisible = ({
  enable,
  isExpandable,
  isExpanded,
}: {
  enable: boolean;
  isExpandable: boolean;
  isExpanded: boolean;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
}) => isExpandable && (!isExpanded || (isExpanded && enable));
